"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'cs-CZ': {
        afterCallGuest: 'https://www.lifesize.com/cs/ldp/guest-call',
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/cs/app-help',
        helpGuest: 'https://www.lifesize.com/cs/app-help/guest',
        privacy: 'https://www.lifesize.com/cs/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'de-DE': {
        afterCallGuest: 'https://www.lifesize.com/de/ldp/guest-call',
        cookie: 'https://www.lifesize.com/de/Firma/Rechtliches/cookie-compliance',
        help: 'https://www.lifesize.com/de/app-help',
        helpGuest: 'https://www.lifesize.com/de/app-help/guest',
        privacy: 'https://www.lifesize.com/de/Firma/Rechtliches/Datenschutz',
        tos: 'https://www.lifesize.com/de/Firma/Rechtliches/terms-of-service'
    },
    'en-US': {
        afterCallGuest: 'https://www.lifesize.com/en/ldp/guest-call',
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/en/app-help',
        helpGuest: 'https://www.lifesize.com/en/app-help/guest',
        privacy: 'https://www.lifesize.com/en/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'es-ES': {
        afterCallGuest: 'https://www.lifesize.com/es/ldp/guest-call',
        cookie: 'https://www.lifesize.com/es/empresa/asuntos-legales/cookie-compliance',
        help: 'https://www.lifesize.com/es/app-help',
        helpGuest: 'https://www.lifesize.com/es/app-help/guest',
        privacy: 'https://www.lifesize.com/es/empresa/asuntos-legales/privacidad',
        tos: 'https://www.lifesize.com/es/empresa/asuntos-legales/terms-of-service'
    },
    'fi-FI': {
        afterCallGuest: 'https://www.lifesize.com/fi/ldp/guest-call',
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/fi/app-help',
        helpGuest: 'https://www.lifesize.com/fi/app-help/guest',
        privacy: 'https://www.lifesize.com/fi/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'fr-FR': {
        afterCallGuest: 'https://www.lifesize.com/fr/ldp/guest-call',
        cookie: 'https://www.lifesize.com/fr/soci%C3%A9t%C3%A9/mentions-l%C3%A9gales/cookie-compliance',
        help: 'https://www.lifesize.com/fr/app-help',
        helpGuest: 'https://www.lifesize.com/fr/app-help/guest',
        privacy: 'https://www.lifesize.com/fr/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/fr/soci%C3%A9t%C3%A9/mentions-l%C3%A9gales/terms-of-service'
    },
    'it-IT': {
        afterCallGuest: 'https://www.lifesize.com/it/ldp/guest-call',
        cookie: 'https://www.lifesize.com/it/azienda/note-legali/cookie-compliance',
        help: 'https://www.lifesize.com/it/app-help',
        helpGuest: 'https://www.lifesize.com/it/app-help/guest',
        privacy: 'https://www.lifesize.com/it/azienda/note-legali/privacy',
        tos: 'https://www.lifesize.com/it/azienda/note-legali/terms-of-service'
    },
    'ja-JP': {
        afterCallGuest: 'https://www.lifesize.com/ja/ldp/guest-call',
        cookie: 'https://www.lifesize.com/ja/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/ja/app-help',
        helpGuest: 'https://www.lifesize.com/ja/app-help/guest',
        privacy: 'https://www.lifesize.com/ja/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/ja/company/legal-notices/terms-of-service'
    },
    'ko-KR': {
        afterCallGuest: 'https://www.lifesize.com/ko/ldp/guest-call',
        cookie: 'https://www.lifesize.com/ko/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/en/app-help',
        helpGuest: 'https://www.lifesize.com/ko/app-help/guest',
        privacy: 'https://www.lifesize.com/ko/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/ko/company/legal-notices/terms-of-service'
    },
    'nl-NL': {
        afterCallGuest: 'https://www.lifesize.com/nl/ldp/guest-call',
        cookie: 'https://www.lifesize.com/nl/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/nl/app-help',
        helpGuest: 'https://www.lifesize.com/nl/app-help/guest',
        privacy: 'https://www.lifesize.com/nl/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/nl/company/legal-notices/terms-of-service'
    },
    'no-NO': {
        afterCallGuest: 'https://www.lifesize.com/no/ldp/guest-call',
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/no/app-help',
        helpGuest: 'https://www.lifesize.com/no/app-help/guest',
        privacy: 'https://www.lifesize.com/no/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'pl-PL': {
        afterCallGuest: 'https://www.lifesize.com/pl/ldp/guest-call',
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/pl/app-help',
        helpGuest: 'https://www.lifesize.com/pl/app-help/guest',
        privacy: 'https://www.lifesize.com/pl/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/en/company/legal-notices/terms-of-service'
    },
    'pt-BR': {
        afterCallGuest: 'https://www.lifesize.com/pt/ldp/guest-call',
        cookie: 'https://www.lifesize.com/pt/empresa/avisos-legais/cookie-compliance',
        help: 'https://www.lifesize.com/pt/app-help',
        helpGuest: 'https://www.lifesize.com/pt/app-help/guest',
        privacy: 'https://www.lifesize.com/pt/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/pt/empresa/avisos-legais/terms-of-service'
    },
    'ru-RU': {
        afterCallGuest: 'https://www.lifesize.com/ru/ldp/guest-call',
        cookie: 'https://www.lifesize.com/en/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/ru/app-help',
        helpGuest: 'https://www.lifesize.com/ru/app-help/guest',
        privacy: 'https://www.lifesize.com/ru/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/ru/company/legal-notices/terms-of-service'
    },
    'sv-SE': {
        afterCallGuest: 'https://www.lifesize.com/sv/ldp/guest-call',
        cookie: 'https://www.lifesize.com/sv/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/sv/app-help',
        helpGuest: 'https://www.lifesize.com/sv/app-help/guest',
        privacy: 'https://www.lifesize.com/sv/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/sv/company/legal-notices/terms-of-service'
    },
    'zh-Hans': {
        afterCallGuest: 'https://www.lifesize.com/zh-Hans',
        cookie: 'https://www.lifesize.com/zh-Hans/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/zh-Hans/app-help',
        helpGuest: 'https://www.lifesize.com/zh-Hans/app-help/guest',
        privacy: 'https://www.lifesize.com/zh-CN/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/zh-Hans/company/legal-notices/terms-of-service'
    },
    'zh-Hant': {
        afterCallGuest: 'https://www.lifesize.com/zh-Hant',
        cookie: 'https://www.lifesize.com/zh-Hans/company/legal-notices/cookie-compliance',
        help: 'https://www.lifesize.com/zh-Hans/app-help',
        helpGuest: 'https://www.lifesize.com/zh-Hans/app-help/guest',
        privacy: 'https://www.lifesize.com/zh-TW/company/legal-notices/privacy',
        tos: 'https://www.lifesize.com/zh-Hant/company/legal-notices/terms-of-service'
    }
};
//# sourceMappingURL=compliance.js.map